import { observer } from 'mobx-react';
import React from 'react';
import client from "../feathers";
import { Services } from "types";

import { Box, Grid } from '@mui/material';
import { Page } from 'components';

export interface IEmailProps { }


/**
 * 
 * 
 * @type all
 */
export const Email = observer((props: IEmailProps) => {
  const tryEmail = () => {
    client.service(Services.Email).create({
      bla: 'bla bla'
    })
  }
  return (
    <Page>
      <Grid
        container
        spacing        = {0}
        direction      = 'column'
        alignItems     = 'center'
        justifyContent = 'center'
        style          = {{ minHeight: '100vh' }}
      >
        <Grid item xs = {3}>
          <Box
            display        = 'flex'
            justifyContent = 'center'
            alignItems     = 'center'
            flexDirection  = 'column'
          >
            <button onClick={tryEmail}>Email me</button>
          </Box>
        </Grid>
      </Grid>
    </Page>
  );
});